import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuildingColumns,
  faCloud,
  faUnlockKeyhole,
  faUser,
  faSearch,
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import adminService from "../../../Services/apiService/admin-service";
import { useAuth } from "../../../Utils/Auth";
import FullScreenLoader from "../../../Component/FullScreenLoader";
import NewPagination from "../../../Component/DashBoard/NewPagination";
// import Pagination from "../../../Component/DashBoard/Pagination";
import AdminPermissionDialog from './permission'
import { toast } from "react-toastify";
import { customErrorHandler, toTitleCase } from "../../../Utils/helper";
import ShowAdminBankWebsitePermission from './banks_website_permission'
import EditAdminProfile from "./editProfile";
import Dropdown from 'react-bootstrap/Dropdown';
import AdminPasswordReset from "./resetPassword";
import AccountService from "../../../Services/AccountService";
const AdminDashboard = () => {
  const navigate = useNavigate();
  const [adminList, setAdminList] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [permissionfieldValues, setPermissionFieldValue] = useState([])
  const [permissionDialog, setPermissionDialog] = useState({
    show: false,
    data: {}
  })
  const [bankWebsiteDialog, setBankWebsiteDialog] = useState({
    show: false,
    data: [],
    callingFor: ''
  });

  const [editProfileDialog, setEditProfileDialog] = useState({
    show: false,
    firstName: '',
    lastName: '',
    copiedCredentials: {

    },
    
    // callingFor : ''
  });

  const [adminPasswordChange, setAdminPasswordChange] = useState({
    show: false,
    adminName : '',
    password: '',
    confirmPassword: ''
  });


  const pageLimit = 12;
  const auth = useAuth();

  const startIndex = Math.min((page - 1) * pageLimit + 1);
  const endIndex = Math.min(page * pageLimit, totalData);

  const handleSearch = (event) => {
    setSearch(event.target.value);
    if (!event.target.value) {
      setAdminList([]);
    }
  };

  const fetchData = async (searchTerm = search, newPage = page) => {
    setIsLoading(true);
    try {
      const res = await adminService.getAdminProfile(
        auth.user,
        newPage,
        searchTerm
      );
      const filteredData = res.data.data.filter((item) => item !== null);
      setAdminList(filteredData);
      setTotalData(res?.data?.pagination?.totalItems);
      setTotalPages(res?.data?.pagination?.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const debouncedSearchHandler = useCallback(
    debounce((searchTerm) => {
      setPage(1);
      fetchData(searchTerm, 1);
    }, 500),
    []
  );

  useEffect(() => {
    debouncedSearchHandler(search);
    return () => debouncedSearchHandler.cancel();
  }, [search, debouncedSearchHandler]);

  useEffect(() => {
    fetchData();
  }, [page]);

  const handleProfileClick = (id) => {
    navigate(`/subadminedit/${id.adminId}`);
  };

  const selectPageHandler = (selectedPage) => {
    setPage(selectedPage);
  };

  const handleOpenPermissionDialog = (data) => {
    setPermissionDialog((state) => ({
      ...state,
      show: true,
      data: data,
    }))
    setPermissionFieldValue(data?.roles)
  }

  const handleClosePermissionClose = () => {
    setPermissionDialog((state) => ({
      ...state,
      show: false
    }))
    setPermissionFieldValue([])
  }

  const handlePermissionSubmit = (id) => {
    adminService.updateAdminPermission(
      id,
      { roles: permissionfieldValues },
      auth.user
    )
      .then((res) => {
        console.log(res);
        toast.success(toTitleCase(res.data.message) || "update successfully");
        fetchData()
        handleClosePermissionClose()
      })
      .catch((err) => {
        toTitleCase(customErrorHandler(err))
      });
  };

  const handleShowBankDialog = (data) => {
    setBankWebsiteDialog((state) => ({
      ...state,
      show: true,
      data: data.banks,
      callingFor: 'bank'
    }))
  }

  const handleShowWebsiteDialog = (data) => {
    setBankWebsiteDialog((state) => ({
      ...state,
      show: true,
      data: data.websites,
      callingFor: 'website'
    }))
  }

  const handleCloseBankWebsiteDialog = () => {
    setBankWebsiteDialog((state) => ({
      ...state,
      show: false,
      data: []
    }))
  }

  const handleShowEditProfileDialog = (data) => {
    setEditProfileDialog((state) => ({
      ...state,
      show: true,
      firstName: data.firstName,
      lastName: data.lastName,
      id: data.adminId,
      copiedCredentials:{
        firstName:data.firstName,
        lastName:data.lastName
      }
    }))
  }

  const handleCloseEditProfileDialog = () => {
    setEditProfileDialog((state) => ({
      ...state,
      show: false,
      firstName: '',
      lastName: ''
    }))
  }

  const handleSubAdminProfileChange = (e) => {
    const { name, value } = e.target;
    setEditProfileDialog(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const subAdminProfileOnSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      firstName: editProfileDialog.firstName,
      lastName: editProfileDialog.lastName,
    };
    try {
      const res = await adminService.editsubadminprofile(
        editProfileDialog.id,
        payload,
        auth.user
      );
      if (res) {
        toast.success(toTitleCase(res.data.message));
        handleCloseEditProfileDialog()
        fetchData()
      }
    } catch (error) {
      toTitleCase(customErrorHandler(error))
    }
  };

  const handlePasswordOnChange = (e) =>{
        const { name, value } = e.target;
    setAdminPasswordChange(prev => ({
      ...prev,
      [name]: value
    }));
  }
  

  const handlePasswordDialogOpen = (data) => {
    setAdminPasswordChange((state) => ({
      ...state,
      show: true,
      adminName: data.userName,
    }))
  }

  const handlePasswordDialogClose = (e) => {
    setAdminPasswordChange((state) => ({
      ...state,
      show: false,
      adminName: '',
      password: '',
      confirmPassword: ''
    }))
  }


  const handlePasswordOnSubmit = async (e, userName) => {
    e.preventDefault();
    try {
      const data = {
        userName: userName,
        password: adminPasswordChange.confirmPassword,
      };

      const res = await adminService.resetPassword(data, auth.user);

      if (res) {
        toast.success(toTitleCase(res?.data?.message || "Something Went Wrong"));
        setAdminPasswordChange({
          show: false,
          adminName: '',
          password: '',
          confirmPassword: ''
        })
      }
    } catch (error) {
      toast.error(customErrorHandler(error))
    }
  };


  return (
    <div className="admin-dashboard-container">
      <FullScreenLoader show={isLoading} />

      {/* Header Section */}
      <div className="dashboard-header">
        <h2 className="dashboard-title">Admin Management</h2>
        <div className="search-container">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="search"
            className="search-input"
            placeholder="Search Admins By Name..."
            value={search}
            onChange={handleSearch}
          />
        </div>
      </div>

      {/* Stats Overview */}
      <div className="stats-overview">
        <div className="stat-card">
          <h3>Total Admins</h3>
          <p className="admin-role">{totalData}</p>
        </div>
        <div className="stat-card">
          <h3>Active This Month</h3>
          <p className="admin-role">24</p>
        </div>
        <div className="stat-card">
          <h3>New This Week</h3>
          <p className="admin-role" >5</p>
        </div>
      </div>

      {/* Admin Cards Grid */}
      <div className="admin-grid-container">
        {adminList.length > 0 ? (
          <div className="admin-grid">
            {adminList.map((admin) => (
              <div
                key={admin.adminId}
                className={`admin-card ${hoveredCard === admin.adminId ? 'hovered' : ''}`}
                onMouseEnter={() => setHoveredCard(admin.adminId)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="admin-card-header">
                  <div className="admin-avatar">
                    {admin.userName.charAt(0).toUpperCase()}
                  </div>
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      variant="link"
                      bsPrefix="p-0 border-0 bg-transparent"
                      id="dropdown-ellipsis"
                    >
                        <button className="menu-button">
                    <FontAwesomeIcon icon={faEllipsisVertical} />
                  </button>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item className="menu-button" onClick={()=>handlePasswordDialogOpen(admin)}>Change Password</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div className="admin-info">
                  <h3 className="admin-name">{admin.userName}</h3>
                  <p className="admin-email">{`${admin.firstName} ${admin.lastName}`}</p>
                  <p className="admin-role">Sub Admin</p>
                </div>

                <div className="admin-actions">
                  <button
                    className="action-button"
                    onClick={() => handleShowEditProfileDialog(admin)}
                    title="Edit Profile"
                  >
                  <FontAwesomeIcon icon={faUser} />
                  </button>
                  <button className="action-button" title="Permissions" onClick={() => handleOpenPermissionDialog(admin)}>
                    <FontAwesomeIcon icon={faUnlockKeyhole} />
                  </button>
                  <button className="action-button" title="Assigned Banks" onClick={() => { handleShowBankDialog(admin) }}>
                    <FontAwesomeIcon icon={faBuildingColumns} />
                  </button>
                  <button className="action-button" title="Assigned Websites" onClick={() => { handleShowWebsiteDialog(admin) }}>
                    <FontAwesomeIcon icon={faCloud} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-results">
            <p>No Admins Found</p>
          </div>
        )}
      </div>

      {/* Pagination */}
      {adminList.length > 0 && (
        <span className="m-4">
          <NewPagination
            currentPage={page}
            totalPages={totalPages}
            handlePageChange={selectPageHandler}
            startIndex={startIndex}
            endIndex={endIndex}
            totalData={totalData}
          />
        </span>
      )}

      <AdminPermissionDialog setFieldValue={setPermissionFieldValue} fieldValues={permissionfieldValues} show={permissionDialog.show}
        onHide={handleClosePermissionClose} data={permissionDialog.data} onSubmit={handlePermissionSubmit} />
      <ShowAdminBankWebsitePermission show={bankWebsiteDialog.show} handleClose={handleCloseBankWebsiteDialog} data={bankWebsiteDialog.data} callingFor={bankWebsiteDialog.callingFor} />
      <EditAdminProfile show={editProfileDialog.show} firstName={editProfileDialog.firstName} lastName={editProfileDialog.lastName} copiedCredentials={editProfileDialog.copiedCredentials} handleChange={handleSubAdminProfileChange} onSave={subAdminProfileOnSubmit} onHide={handleCloseEditProfileDialog} />
      <AdminPasswordReset show={adminPasswordChange.show}  adminName={adminPasswordChange.adminName}  form={adminPasswordChange}  handleChange={handlePasswordOnChange} onSave={handlePasswordOnSubmit} onHide={handlePasswordDialogClose}/>
      {/* CSS Styles */}
      <style jsx>{`
        .admin-dashboard-container {
          padding: 2rem;
          background-color: #f8fafc;
          min-height: 100vh;
        }
        
        .dashboard-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
        }
        
        .dashboard-title {
          font-size: 1.8rem;
          color: #1e293b;
          font-weight: 600;
        }
        
        .search-container {
          position: relative;
          width: 300px;
        }
        
        .search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #64748b;
        }
        
        .search-input {
          width: 100%;
          padding: 0.75rem 1rem 0.75rem 2.5rem;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          background-color: #fff;
          font-size: 0.9rem;
          transition: all 0.2s;
        }
        
        .search-input:focus {
          outline: none;
          border-color: #4682b4;
          box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
        }
        
        .stats-overview {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1rem;
          margin-bottom: 2rem;
        }
        
        .stat-card {
          background: white;
          border-radius: 10px;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        
        .stat-card h3 {
          font-size: 0.9rem;
          color: #64748b;
          margin-bottom: 0.5rem;
        }
        
        .stat-card p {
          font-size: 1.5rem;
          font-weight: 600;
          color: #1e293b;
        }
        
        .admin-grid-container {
          margin-top: 1.5rem;
        }
        
        .admin-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 1.5rem;
        }
        
        .admin-card {
          background: white;
          border-radius: 12px;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          transition: all 0.2s ease;
          border: 1px solid #e2e8f0;
        }
        
        .admin-card.hovered {
          transform: translateY(-4px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          border-color: #c7d2fe;
        }
        
        .admin-card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
        }
        
        .admin-avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background-color: #4682b4;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          font-weight: 600;
        }
        
        .menu-button {
          background: none;
          border: none;
          color: #64748b;
          cursor: pointer;
          padding: 0.5rem;
        }
        
        .admin-info {
          margin-bottom: 1.5rem;
        }
        
        .admin-name {
          font-size: 1.1rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 0.25rem;
        }
        
        .admin-email {
          font-size: 0.85rem;
          color: #64748b;
          margin-bottom: 0.5rem;
        }
        
        .admin-role {
          display: inline-block;
          background-color: #e0e7ff;
          color: #4682b4;
          padding: 0.25rem 0.75rem;
          border-radius: 9999px;
          font-size: 0.75rem;
          font-weight: 500;
        }
        
        .admin-actions {
          display: flex;
          justify-content: space-around;
          border-top: 1px solid #f1f5f9;
          padding-top: 1rem;
        }
        
        .action-button {
          background: none;
          border: none;
          color: #64748b;
          cursor: pointer;
          padding: 0.5rem;
          transition: all 0.2s;
          border-radius: 50%;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .action-button:hover {
          background-color: #f1f5f9;
          color: #4682b4;
        }
        
        .no-results {
          text-align: center;
          padding: 3rem;
          background: white;
          border-radius: 10px;
          color: #64748b;
          font-size: 1.1rem;
        }
      `}</style>
    </div>
  );
};

export default AdminDashboard;